// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForwardFilledSvg from "@fishx/icons-svg/es/asn/ForwardFilled";
import FishxIcon from '../components/FishxIcon';

var ForwardFilled = function ForwardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForwardFilledSvg
  }));
};

ForwardFilled.displayName = 'ForwardFilled';
export default React.forwardRef(ForwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ForwardFilled.js
// module id = 2830
// module chunks = 0